import dynamic from 'next/dynamic'
import React from 'react'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { TopToolbar } from 'src/components/insights/top-toolbar'
import { InsightPage } from 'src/components/insights/page'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { Colors } from 'src/components/theme'
import { InsightDownload } from 'src/views/insight-download'
import { OwnerSearchIcon } from 'src/components/insights/icons/owner-search'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'

const OwnerSearchContent = dynamic(() => import('src/components/insights/owner-search-legacy/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const OwnerSearchPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props

  return (
    <InsightPage>
      <React.Suspense fallback={<FullScreenLoading />}>
        <TopToolbar insight={insight} color={Colors.orangeDark} actions={<InsightDownload fileName="Owner Search" />} />
        <OwnerSearchContent />
      </React.Suspense>
    </InsightPage>
  )
}

export const OwnerSearchLegacy: Insight = {
  id: 'owner-search-legacy',
  component: OwnerSearchPage,
  name: 'Owner Search (Legacy)',
  icon: OwnerSearchIcon,
  supportedResultTypes: ['venue', 'address', 'alphamap-location'],
  linkTooltipFile: 'insights-link-owner-search',
  tier: INSIGHTS_TIER['Ownership'],
}
